import React, {Fragment}  from 'react';
import { ieCheck } from '../../../helpers/utils';
import _filter from 'lodash/filter';
import Slider from "react-slick";
import { renderDateText, renderTimeDate, renderStartEndLocation, renderDurationText, sectorWithImagesAndInfo } from '../../../helpers/cyoaHelper';
import { CYOA_NETWORK_IDS } from '../../../config';

const  NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className="arrow-wrapper arrow-wrapper-next" onClick={onClick}>
    <div
      className={className}
      style={{ ...style, display: "block" }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
        <path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"/>
      </svg>
  </div>
  </div>
  );
}

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className="arrow-wrapper arrow-wrapper-prev" onClick={onClick}>
      <div
        className={className}
        style={{ ...style, display: "block" }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
          <path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/>
        </svg>
      </div>
    </div>
  );
}

const ITINERARY_SLICK_SETTINGS = {
  cssEase: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
  arrows:true,
  prevArrow:<PrevArrow  />,
  nextArrow:<NextArrow />,
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,
  responsive: [
   {
     breakpoint: 1024,
     settings: {
       slidesToShow: 3,
       slidesToScroll: 1,
       arrows:false
     }
   },
   {
     breakpoint: 700,
     settings: {
       slidesToShow: 2,
       slidesToScroll: 1,
       arrows:false
     }
   },
   {
     breakpoint: 480,
     settings: {
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows:false
     }
   }
 ]
}




const ItinerarySlider = (props) => {

    const imageObj = {
      imageQuality:60
    }

  
    const imageURL = (img) => {
      return (_filter(img, {'title': 'hero'})[0] && _filter(img, {'title': 'hero'})[0].url !== undefined) ? _filter(img, {'title': 'hero'})[0].url : "";
    }

    const standardImg = (index, alldata) => {
      
      const dateText = () => {
        if(index === 0 || index === alldata.length - 1){
          return (
            <Fragment>
                <span>{renderDateText(alldata, index, "DD", "start") } </span>
                    {renderDateText(alldata, index, "MMMM", "start") } 
            </Fragment>
          )
        }else{
          return (
            <Fragment>
              <span>{renderDateText(alldata, index, "DD", "start") } </span>
                  {renderDateText(alldata, index, "MMMM", "start") } -
                  <span> {renderDateText(alldata, index, "DD", "end") } </span>
              {renderDateText(alldata, index, "MMMM", "end") }
            </Fragment>
          )
        }
      }


      return (
        <div className="image-wrapper">
          <img
            alt=""
            data-srcset={`https:${imageURL(alldata[index].images)}?w=498&q=${imageObj.imageQuality} 1x,
            https:${imageURL(alldata[index].images)}?w=698&q=${imageObj.imageQuality} 2x`}
            data-src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            className="lazyload" />
            <span className="overlay"></span>
            <div className={`itinerary-overlay ${alldata[index].type}`}>
                <p className="duration-text">
                  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 0C3.133 0 0 3.133 0 7s3.133 7 7 7 7-3.133 7-7-3.133-7-7-7zm6.097 7A6.097 6.097 0 1 1 .903 7a6.097 6.097 0 1 1 12.194 0zM8.894 9.492L6.602 7.827a.34.34 0 0 1-.138-.274V3.048a.34.34 0 0 1 .338-.338h.396a.34.34 0 0 1 .338.338v4.13l1.99 1.448c.153.11.184.322.074.474l-.232.319a.341.341 0 0 1-.474.073z" fill="#F60" fillRule="nonzero"/>
                  </svg>
                  {renderDurationText(alldata, index)}
                </p>
                <p className="month-text">
                  {dateText()}
                </p>
                <ul style={{display:index === alldata.length - 1 ? 'none' : 'block'}}>
                  <li>
                    <div className="row">
                      <div className="column small-2 no-padding-right">
                        <svg width="16" height="21" viewBox="0 0 16 21" xmlns="http://www.w3.org/2000/svg">
                          <g fill="#FFFFFF" fillRule="nonzero">
                            <path d="M7.98 11.777a4.382 4.382 0 1 1 0-8.763 4.382 4.382 0 0 1 0 8.763zm0-7.64a3.259 3.259 0 1 0 0 6.517 3.259 3.259 0 0 0 0-6.517z"/>
                            <path d="M7.98 9.867a2.472 2.472 0 1 1 0-4.943 2.472 2.472 0 0 1 0 4.943zm0-3.82a1.349 1.349 0 1 0 0 2.698 1.349 1.349 0 0 0 0-2.698z"/>
                            <path d="M10.746 17.5a.561.561 0 0 1-.454-.89c.98-1.353 3.616-5.108 4.05-6.226.299-.706.466-1.46.494-2.226 0-1.999-.708-3.777-1.995-5.008A6.478 6.478 0 0 0 8.004 1.41h-.049A6.493 6.493 0 0 0 3.119 3.15C1.83 4.38 1.123 6.16 1.123 8.158c.018.639.14 1.27.363 1.87.41 1.188 3.377 5.143 4.485 6.566a.561.561 0 0 1-.885.69c-.42-.539-4.116-5.31-4.661-6.89A6.96 6.96 0 0 1 0 8.158c0-2.308.832-4.375 2.342-5.82A7.602 7.602 0 0 1 7.98.288c2.08-.12 4.12.621 5.637 2.05 1.51 1.445 2.342 3.512 2.342 5.82a7.413 7.413 0 0 1-.57 2.632c-.575 1.481-4.04 6.275-4.188 6.478a.561.561 0 0 1-.455.232zM7.98 20.937a.561.561 0 0 1-.397-.164l-1.587-1.587a.561.561 0 0 1 .794-.794l1.19 1.19 1.19-1.19a.561.561 0 0 1 .793.794l-1.586 1.587a.561.561 0 0 1-.397.164z"/>
                          </g>
                        </svg>
                      </div>

                      <div className="column small-10 no-padding-left">
                        <p className="bold title">Trip meeting point</p>
                        <p>{ renderStartEndLocation(index, alldata, "start") }</p>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="row" style={{display: renderTimeDate(alldata, index, 'start') === "" ? 'none' : 'block' }}>
                      <div className="column small-2 no-padding-right">

                        <svg width="16" height="23" viewBox="0 0 16 23" xmlns="http://www.w3.org/2000/svg">
                          <g fill="#FFFFFF" fillRule="nonzero">
                            <path d="M13.542 22.845H3.072a2.151 2.151 0 0 1-2.15-2.149v-5.505a.653.653 0 1 1 1.307 0v5.505c0 .465.377.842.842.843h10.47a.844.844 0 0 0 .844-.843V2.15a.844.844 0 0 0-.843-.843H3.072a.844.844 0 0 0-.843.843v5.205a.653.653 0 1 1-1.306 0V2.149A2.151 2.151 0 0 1 3.07 0h10.47a2.151 2.151 0 0 1 2.15 2.149v18.547a2.151 2.151 0 0 1-2.15 2.149z"/>
                            <path d="M11.568 13.17a1.748 1.748 0 1 1 0-3.495 1.748 1.748 0 0 1 0 3.496zm0-2.19a.442.442 0 1 0 0 .884.442.442 0 0 0 0-.883zM.653 13.922a.653.653 0 0 1-.462-1.115l1.384-1.385L.191 10.04a.653.653 0 0 1 .924-.924l1.845 1.846a.653.653 0 0 1 0 .923L1.115 13.73a.65.65 0 0 1-.462.192z"/>
                          </g>
                        </svg>
                      </div>
                      <div className="column small-10 no-padding-left">
                        <p className="bold title">{(alldata[index].tour_id === CYOA_NETWORK_IDS["europe"].id || alldata[index].tour_id === CYOA_NETWORK_IDS["usa"].id ) ? 'Drop-off' : 'Start'}</p>
                        <p>{ renderTimeDate(alldata, index, 'start') }</p>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="row" style={{display: renderTimeDate(alldata, index, 'end') === "" ? 'none' : 'block' }}>
                      <div className="column small-2 no-padding-right">
                        <svg width="16" height="23" viewBox="0 0 16 23" xmlns="http://www.w3.org/2000/svg">
                          <g fill="#FFFFFF" fillRule="nonzero">
                            <path d="M13.542 22.845H3.072a2.151 2.151 0 0 1-2.15-2.149v-5.505a.653.653 0 1 1 1.307 0v5.505c0 .465.377.842.842.843h10.47a.844.844 0 0 0 .844-.843V2.15a.844.844 0 0 0-.843-.843H3.072a.844.844 0 0 0-.843.843v5.205a.653.653 0 1 1-1.306 0V2.149A2.151 2.151 0 0 1 3.07 0h10.47a2.151 2.151 0 0 1 2.15 2.149v18.547a2.151 2.151 0 0 1-2.15 2.149z"/>
                            <path d="M11.568 13.17a1.748 1.748 0 1 1 0-3.495 1.748 1.748 0 0 1 0 3.496zm0-2.19a.442.442 0 1 0 0 .884.442.442 0 0 0 0-.883zM.653 13.922a.653.653 0 0 1-.462-1.115l1.384-1.385L.191 10.04a.653.653 0 0 1 .924-.924l1.845 1.846a.653.653 0 0 1 0 .923L1.115 13.73a.65.65 0 0 1-.462.192z"/>
                          </g>
                        </svg>
                      </div>
                      <div className="column small-10 no-padding-left">
                        <p className="bold title">{ (alldata[index].tour_id === CYOA_NETWORK_IDS["europe"].id || alldata[index].tour_id === CYOA_NETWORK_IDS["usa"].id )  ? 'Next pick-up' : 'End'}</p>
                        <p>{ renderTimeDate(alldata, index, 'end') }</p>
                      </div>
                    </div>
                  </li>

                  <li style={{display: (alldata[index].tour_id !== CYOA_NETWORK_IDS["europe"].id || alldata[index].tour_id !== CYOA_NETWORK_IDS["usa"].id)  ? 'none' : 'block'}}>
                    <div className="row">
                      <div className="column small-2 no-padding-right">
                        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <g fill="#FFFFFF" fillRule="nonzero">
                            <path d="M10.5 18a47.708 47.708 0 0 1-5.777-.357A1.97 1.97 0 0 1 3 15.688V4.633A4.638 4.638 0 0 1 7.632 0h5.736A4.638 4.638 0 0 1 18 4.633v11.055a1.97 1.97 0 0 1-1.723 1.955A47.707 47.707 0 0 1 10.5 18zM7.632 1.065a3.571 3.571 0 0 0-3.567 3.568v11.055c0 .455.338.84.79.898 1.873.23 3.758.347 5.645.349a46.658 46.658 0 0 0 5.645-.35.905.905 0 0 0 .79-.897V4.633a3.571 3.571 0 0 0-3.567-3.568H7.632z"/>
                            <path d="M3.533 4C3.239 4 3 3.78 3 3.508s.238-.492.532-.493L17.467 3c.294 0 .533.22.533.492s-.238.492-.532.493L3.533 4zM17.468 11H3.532C3.238 11 3 10.776 3 10.5s.238-.5.532-.5h13.936c.294 0 .532.224.532.5s-.238.5-.532.5zM7.517 20H6.484C5.664 20 5 19.46 5 18.793v-1.337c0-.128.066-.25.182-.336a.645.645 0 0 1 .428-.118l2.878.204c.29.02.512.218.512.454v1.133C9 19.46 8.336 20 7.517 20zm-1.395-2.047v.84c0 .163.162.295.362.295h1.033c.2 0 .361-.132.362-.295v-.715l-1.757-.125zM14.516 20h-1.032c-.82-.001-1.483-.711-1.484-1.587v-1.491c0-.308.217-.565.502-.597l2.879-.322a.537.537 0 0 1 .434.151.62.62 0 0 1 .185.446v1.813c0 .876-.665 1.586-1.484 1.587zm-1.395-2.538v.95c0 .215.163.388.363.388h1.032c.2 0 .362-.173.362-.387v-1.147l-1.757.196zM12.453 13H8.547C8.245 13 8 12.776 8 12.5s.245-.5.547-.5h3.906c.302 0 .547.224.547.5s-.245.5-.547.5zM12.453 15H8.547C8.245 15 8 14.776 8 14.5s.245-.5.547-.5h3.906c.302 0 .547.224.547.5s-.245.5-.547.5zM12.453 3H8.547C8.245 3 8 2.776 8 2.5s.245-.5.547-.5h3.906c.302 0 .547.224.547.5s-.245.5-.547.5z"/>
                            <path d="M19.433 6a.572.572 0 0 1-.566-.576 1.167 1.167 0 0 0-.432-.834c-.723-.551-1.784-.426-1.796-.424a.569.569 0 0 1-.634-.498.575.575 0 0 1 .49-.645c.06-.009 1.522-.192 2.62.645A2.33 2.33 0 0 1 20 5.424a.572.572 0 0 1-.567.576z"/>
                            <path d="M19.565 9h-.511C18.472 9 18 8.359 18 7.568V5.59c0-.326.195-.59.435-.59h1.13c.24 0 .435.264.435.59v2.82c0 .326-.195.59-.435.59zm-.696-2.82v1.388c0 .139.083.251.185.251h.077V6.181h-.262zM.567 6H.559A.569.569 0 0 1 0 5.427c.023-.691.347-1.335.884-1.758 1.099-.839 2.56-.655 2.622-.646.31.04.53.33.49.646a.569.569 0 0 1-.635.499c-.018-.003-1.076-.126-1.797.425a1.168 1.168 0 0 0-.43.84A.575.575 0 0 1 .566 6z"/>
                            <path d="M.946 9H.435C.195 9 0 8.736 0 8.41V5.59C0 5.264.195 5 .435 5h1.13c.24 0 .435.264.435.59V7.57C2 8.359 1.528 8.999.946 9zM.87 7.82h.077c.102 0 .185-.113.185-.252V6.181H.869v1.638zM5.598 15H3.595C3.266 15 3 14.774 3 14.495v-1.99c0-.279.266-.505.595-.505h2.003C6.372 12 7 12.533 7 13.19v.62C7 14.467 6.372 15 5.598 15zM4.19 13.99h1.408c.117 0 .212-.08.212-.18v-.62c0-.1-.095-.18-.212-.18H4.19v.98zM17.405 15h-2.003C14.628 15 14 14.467 14 13.81v-.62c0-.657.628-1.19 1.402-1.19h2.003c.329 0 .595.226.595.505v1.99a.47.47 0 0 1-.174.357.652.652 0 0 1-.42.148zm-2.003-1.99c-.117 0-.212.08-.212.18v.62c0 .1.095.18.212.18h1.408v-.98h-1.408zM13.596 9a.594.594 0 1 1-.005-1.186l1.222-.012v-1.21a.593.593 0 0 1 1.187 0V8.39c0 .325-.262.59-.588.593L13.602 9h-.006z"/>
                          </g>
                        </svg>
                      </div>
                      <div className="column small-10 no-padding-left">
                        <p className="bold title">{alldata[index].next_transfer.text}</p>
                        <p>{alldata[index].next_transfer.sub_text}</p>
                      </div>
                    </div>
                  </li>
                </ul>

            </div>
        </div>
      )
    }

    const ieImg = (img) => {
      return (
        <div className="image-wrapper">
          <img alt="" src={`https:${imageURL(img)}?w=698&q=${imageObj.imageQuality}`} />
        </div>
      )
    }




    if(sectorWithImagesAndInfo(props).length > 0){

      return (
        <Slider {...ITINERARY_SLICK_SETTINGS}>
          {
            sectorWithImagesAndInfo(props).map((item, i) => {
              return (
                <div key={i} className={`itinerary-slide-wrapper ${props.sectors[i].type}`} onClick={() => { if(props.sectors[i].type !== "product") props.onClick(i, item.name) }}>
                  <div className={`circle-dot ${(i === 0) ? 'start-dot' : ''}`}><span>{i}</span></div>
                  <hr/>
                  <div className="itinerary-slide-item">

                    <svg xmlns="http://www.w3.org/2000/svg" width="56.855" height="73.589" viewBox="0 0 56 73" className="marker-svg">
                      <g data-name="Layer 2">
                        <g data-name="Layer 1">
                          <path d="M28.428 40.957a15.61 15.61 0 1 1 15.61-15.61 15.628 15.628 0 0 1-15.61 15.61zm0-27.22a11.61 11.61 0 1 0 11.61 11.61 11.623 11.623 0 0 0-11.61-11.61z"/>
                          <path d="M28.428 34.151a8.805 8.805 0 1 1 8.804-8.804 8.815 8.815 0 0 1-8.804 8.804zm0-13.61a4.805 4.805 0 1 0 4.804 4.806 4.812 4.812 0 0 0-4.804-4.806z"/>
                          <path d="M38.283 61.345a2 2 0 0 1-1.618-3.173c3.49-4.818 12.883-18.196 14.43-22.18a22.51 22.51 0 0 0 1.76-7.93c0-7.12-2.524-13.455-7.11-17.842a23.078 23.078 0 0 0-17.23-6.192q-.087.003-.175 0a23.133 23.133 0 0 0-17.23 6.193C6.524 14.607 4 20.943 4 28.063a20.882 20.882 0 0 0 1.295 6.663c1.46 4.231 12.03 18.319 15.978 23.39a2 2 0 0 1-3.156 2.457C16.622 58.654 3.457 41.656 1.514 36.03A24.792 24.792 0 0 1 0 28.063C0 19.842 2.963 12.479 8.344 7.33A27.08 27.08 0 0 1 28.428.028 27.017 27.017 0 0 1 48.51 7.33c5.38 5.148 8.343 12.512 8.343 20.732a26.408 26.408 0 0 1-2.03 9.377c-2.05 5.278-14.394 22.354-14.919 23.079a1.998 1.998 0 0 1-1.622.827zM28.428 73.589a2 2 0 0 1-1.414-.586L21.36 67.35a2 2 0 0 1 2.828-2.828l4.24 4.24 4.238-4.24a2 2 0 0 1 2.828 2.828l-5.652 5.653a2 2 0 0 1-1.414.586z"/>
                        </g>
                      </g>
                    </svg>

                    <p className="bold no-margin display-line-block city-name">{item.name}</p>

                    { ieCheck() ? ieImg(item.images)  : standardImg(i, props.sectors) }

                  </div>
                </div>
              )
            })
          }
        </Slider>
      )
    }else{
      return null
    }

}



export default ItinerarySlider;



// WEBPACK FOOTER //
// ./src/components/itinerary/components/itinerarySlider.js